'use strict';

var React = require('react');
var date = require('../../../helpers/date.js');
var text = require('../../../helpers/text.js');
require('../../../theme/breakpoints.js');
var useClickAway = require('../../../hooks/useClickAway.js');
require('imask');
var useMaybeControlledValue = require('../../../hooks/useMaybeControlledValue.js');
var useRefAndForward = require('../../../hooks/useRefAndForward.js');
require('resize-observer-polyfill');
var useValidityState = require('../../../hooks/useValidityState.js');
var component = require('../../Icon/component.js');
require('../../Tooltip/component.js');
var component$2 = require('../../Overlay/component.js');
var Small = require('../CalendarMonth/Small.js');
var component$1 = require('../Control/component.js');
var styles = require('./styles.js');
var useDateMask = require('./useDateMask.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const defaultSuffix = React__default.default.createElement(component.Icon, { name: "calendar-outlined", size: "m" });
const DateInput = React.forwardRef(({ value, onChange, onOpenedChange: onOpenedChangeFromProps, isOpened: isOpenedFromProps, variant = 'align-left', overlayMaxHeight, month: monthFromProps, onMonthChange: onMonthChangeFromProps, formatMonth, locale, min, max, onValidityChange, required = false, isUTC = true, pattern = 'DD/MM/YYYY', onClick, suffix = defaultSuffix, ...controlProps }, ref) => {
    const controlRef = useRefAndForward.useRefAndForward(null, ref);
    const overlayRef = React.useRef(null);
    const [inputValue, setInputValue] = React.useState('');
    const [month, onMonthChange] = useMaybeControlledValue.useMaybeControlledValue({
        valueFromProps: monthFromProps,
        onChangeFromProps: onMonthChangeFromProps,
        defaultValue: value || min || max || new Date(),
    });
    const handleChange = React.useCallback(nextValue => {
        const bothNull = !value && !nextValue;
        const valueIsSame = bothNull || (value && nextValue && date.isSameDay(value)(nextValue));
        if (!valueIsSame)
            onChange(nextValue);
        if (nextValue && !date.isSameMonth(month)(nextValue)) {
            onMonthChange(date.startOfMonth(nextValue));
        }
    }, [onChange, month, onMonthChange, value]);
    useDateMask.useDateMask({
        inputRef: controlRef,
        isUTC,
        onChange: handleChange,
        value,
        dateFormat: pattern,
    });
    useValidityState.useValidityState({
        onValidityChange,
        getState: React.useCallback(() => ({
            typeMismatch: !!inputValue && !value,
            valueMissing: required && !value,
            rangeUnderflow: !!value && !!min && date.isBeforeDay(min)(value),
            rangeOverflow: !!value && !!max && date.isAfterDay(max)(value),
        }), [inputValue, min, max, value, required]),
    });
    const [isOpened, onOpenedChange] = useMaybeControlledValue.useMaybeControlledValue({
        valueFromProps: isOpenedFromProps,
        onChangeFromProps: onOpenedChangeFromProps,
        defaultValue: false,
    });
    useClickAway.useClickAway({
        containerRefs: [controlRef, overlayRef],
        listener: React.useCallback(() => {
            if (isOpened)
                onOpenedChange(false);
        }, [isOpened, onOpenedChange]),
    });
    return (React__default.default.createElement(React__default.default.Fragment, null,
        React__default.default.createElement(component$1.Control, { ...controlProps, as: "input", "aria-label": "date input", className: text.classNames(controlProps.className, isOpened && 'focus'), containerClassName: text.classNames(controlProps.containerClassName, isOpened && 'focus-within'), onFocus: (event) => {
                onOpenedChange(true);
                controlProps.onFocus?.(event);
            }, onChange: (event) => setInputValue(event.target.value), ref: controlRef, suffix: suffix }),
        React__default.default.createElement(component$2.Overlay, { variant: variant, isOpened: isOpened, targetRef: controlRef, ref: overlayRef, maxHeight: overlayMaxHeight },
            React__default.default.createElement(styles.Styled.CalendarContainer, null,
                React__default.default.createElement(Small.CalendarMonthSmall, { value: value, onChange: date => handleChange(date), month: month, onMonthChange: onMonthChange, formatMonth: formatMonth, locale: locale, min: min, max: max, required: required, isUTC: isUTC })))));
});

exports.DateInput = DateInput;
//# sourceMappingURL=component.js.map
